import {
    CHIP_SIZES,
    DS_ONLY_VARIANTS,
    LEGACY_VARIANT_CLASSES,
    VARIANT_ALIASES,
} from './constants';

/** Lower-case the variant and resolve camelCase/kebab aliases to a canonical name. */
export const normalizeVariant = (variant) => {
    if (typeof variant !== 'string') return '';
    const lower = variant.toLowerCase();
    return VARIANT_ALIASES[lower] || lower;
};

/**
 * Map a variant prop to its CSS class: legacy names keep their historical bare
 * class, DS-only names get a `chip--` modifier, anything else gets no class.
 */
export const getVariantClass = (variant) => {
    const normalized = normalizeVariant(variant);
    if (LEGACY_VARIANT_CLASSES.has(normalized)) return normalized;
    if (DS_ONLY_VARIANTS.has(normalized)) return `chip--${normalized}`;
    return '';
};

/** Map a size prop to its historical `chip-<size>` class, or no class. */
export const getSizeClass = (size) => (CHIP_SIZES.has(size) ? `chip-${size}` : '');

/**
 * Split group items into the visible and hidden slices.
 * `maxVisible` is honored only when it is a number, so `0` means "hide all"
 * and `undefined` means "show everything".
 */
export const partitionVisibleItems = (items, maxVisible) => {
    const list = Array.isArray(items) ? items : [];
    const limit = typeof maxVisible === 'number' && Number.isFinite(maxVisible)
        ? Math.max(0, Math.floor(maxVisible))
        : list.length;
    return {
        visible: list.slice(0, limit),
        hidden: list.slice(limit),
    };
};
